import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';
import RunAssessmentClientView from "../component/features/run-assessments/RunAssessmentClientView";
import ResultScreen from "../component/features/run-assessments/ResultScreen.jsx";

// import { RunAssessmentList } from "../component/features/run-assessments/RunAssessmentList";
import { RunAssessmentsAdd } from "../component/features/run-assessments/RunAssessmentsAdd";
import Scheduler from "../component/features/run-assessments/Scheduler";


export class SchedulerRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path="/scheduler/add" component={RunAssessmentsAdd} />
                <Route exact path={"/scheduler/"} component={Scheduler} />
                <Route exact path={"/scheduler/client/view/:runassessmentid"} component={RunAssessmentClientView} />
                <Route exact path={"/scheduler/client/view/result/:resultid"} component={ResultScreen} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};